import { type ComponentType, type LazyExoticComponent, lazy } from 'react';

export const lazyImport = <TModule extends Record<string, ComponentType<any>>, TKey extends keyof TModule>(
  importer: () => Promise<TModule>,
  key: TKey,
): LazyExoticComponent<TModule[TKey]> => lazy(() => importer().then(mod => ({ default: mod[key] })));
